import settings from '../../config/settings';
import axiosNonAuth from './axiosNonAuth';
import qs from 'qs';

const {apiBaseUrl} = settings;

export default class CardApi {
  static getCard(id) {
    return axiosNonAuth.get(`${apiBaseUrl}/cards/${id}/?expand=program`);
  }

  static getCollection(id) {
    const query = {expand: 'slots.slot_campaigns.campaign.cards.card.program,slots.slot_campaigns.campaign.poll_campaigns.poll_campaign.cards.card.program'};
    return axiosNonAuth.get(`${apiBaseUrl}/collections/${id}/?${qs.stringify(query)}`);
  }

  static checkIspRedirect(cardId, clientIp) {
    const params = {card: cardId};
    if (clientIp) {
      params.ip = clientIp;
    }
    return axiosNonAuth.post(`${apiBaseUrl}/cards/${cardId}/check-isp-redirect/`, params);
  }

  static checkQuotaRedirect(cardId) {
    return axiosNonAuth.get(`${apiBaseUrl}/cards/${cardId}/check-quota-redirect/`);
  }

  static updateUsedRedirectQuota(cardId, destinationId) {
    return axiosNonAuth.post(`${apiBaseUrl}/cards/${cardId}/update-used-quota/`, {destination: destinationId});
  }

  static getDestinationMatchInfo(cardId, clientIp, postalCode) {
    const query = {};
    if (clientIp) {
      query.ip = clientIp;
    }
    if (postalCode) {
      query.postal_code = postalCode;
    }
    return axiosNonAuth.get(`${apiBaseUrl}/cards/${cardId}/destination-match-info/?${qs.stringify(query)}`);
  }
}
